import React, { Component } from "react";
import AuthService from "../services/AuthService";
import EstudianteService from "../services/EstudianteService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default class Profile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentUser: undefined,
      nombre:'',
      cedula:'',
      email:'',
      isAdmin: false,
      currentEstudiante:undefined
    };
  }

  componentDidMount() {
    // Obtener info del usuario actual
    const user = AuthService.getCurrentUser();
    if (user) {
        const isAdmin = user.roles && user.roles.includes("ROLE_ADMIN");
        this.setState({
            currentUser: user,
            nombre: user.nombre+" "+user.apellido,
            cedula: user.username,
            email: user.email,
            isAdmin: isAdmin
        }, () => {
            // This callback runs after state is updated
            if (!isAdmin) {
                // Obtener Estudiante solo si no es admin
                EstudianteService.getByUsername(user.username)
                    .then(response => {
                        this.setState({
                            currentEstudiante: response.data
                        });
                    })
                    .catch(e => {
                        console.error(e);
                    });
            }
        });
    }
  }

  render() {
    const {
      currentUser, nombre, cedula, email, isAdmin,currentEstudiante
    } = this.state; 
    return (
      <div className="page-bg">
        <div className="container">
          <div className="jumbotron">
            <h3>¡Bienvenido/a, {nombre}!</h3>
            <p className="lead">{cedula}</p>
            <p className="lead text-muted"><FontAwesomeIcon icon="envelope"/> : {email}</p>
            <hr className="my-4"/>
            {currentEstudiante && (
              <div>
                <h5>Estado</h5>
                <p>{currentEstudiante.estado}</p>
                {currentEstudiante.estado === 'SOLICITADO' && (
                  <div className="alert alert-success mt-3" role="alert">
                    <h5 className="alert-heading">¡Proceso completado!</h5>
                    <p>Has culminado con el proceso de inscripción correctamente.</p>
                  </div>
                )}
              </div>
            )}          
          </div>
        </div>
      </div>
    );
  }
}